// extracted by mini-css-extract-plugin
export var notificationHost = "_lg-0";